import Page from './container/page';
import styles from './App.module.less';
import page1Lottie from './assets/lottie/page1.json';
import page2Lottie from './assets/lottie/page2.json';
import page3Lottie from './assets/lottie/page3.json';
import page4Lottie from './assets/lottie/page4.json';
import { isSetDefault, report, getQueryVariable } from '@/utils';

const pageList = [
  {
    titleList: ['QQ浏览器升级', '全新#直达#页'],
    describeText: '自定义添加常用直达入口，支持网址、资讯、小说、文件、小程序等全站内容',
    lottie: page1Lottie,
  },
  {
    titleList: ['如何添加', '#直达#入口'],
    describeText: '点击直达页面“+号”按钮，选取你喜欢的内容或服务进行添加',
    lottie: page2Lottie,
  },
  {
    titleList: ['还可以在这些场景', '添加#直达#'],
    describeText: '在网页、小说、文件、资讯等页面的菜单中找到“添加直达”入口，点击添加',
    lottie: page3Lottie,
  },
  {
    titleList: ['已添加的#直达#', '入口怎么编辑管理？'],
    describeText: '长按图标或点击“+号”进入我的直达页面，按需进行排序和删除',
    lottie: page4Lottie,
  },
  {
    titleList: ['邀请您设置直达为默认首页', '等你来探索和定义'],
    describeText: isSetDefault
      ? ['邀请您设置<span style="color: #017AFF">「直达」</span>为', '默认首页']
      : [
          '更多$<span style="color: #017AFF">「直达」</span>体验',
          '等待你$<span style="color: #017AFF">探索</span>和<span style="color: #017AFF">定义</span>',
        ],
  },
];

if (isSetDefault) {
  const source = getQueryVariable('source');
  report({
    action: 'h5_exp',
    source,
    task_id: getQueryVariable('taskId'),
  });
}

function App() {
  return (
    <div className={styles.app}>
      {pageList.map((v, i) => (
        <Page
          key={i}
          id={`page_${i}`}
          pageIndex={i}
          titleList={v.titleList}
          describeText={v.describeText}
          lottie={v.lottie}
        />
      ))}
    </div>
  );
}

export default App;
